module.exports = __webpack_public_path__ + "static/media/grayson-logo.1e7efacb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/grayson-logo.svg
// module id = 649
// module chunks = 0